export interface Drug {
  id: number;
  name?: string;
  category: string;
  description: string;
  images?: string[];
  composition?: string;
  country_of_origin?: string;
  expiry_date?: string;
  quantity_types?: QuantityDetails[];
}

export interface QuantityDetails {
  id?: number;
  drug_id?: number;
  name?: string;
  is_in_stock?: number | string;
  selling_price?: string;
  partner_price?: string;
}

export interface  DrugCarouselItems {
 category: string;
 groupItems: Drug[];
}
